export default "__VITE_ASSET__BtslyucX__"